import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-display text-3xl text-white">UNLOCKING THE GATES</div>
        <div className="font-mono text-xs text-white/50 mt-3">authenticating...</div>
      </div>
    </div>
  );
}
